import { PatientDocumentName } from './patient-docs-side-panel.model';

export const PATIENT_DOCS_SIDE_PANEL_TITLE_MAP: Record<PatientDocumentName, string> = {
  'DOCTYPE.ADVANCE.HEART':
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.HEART_HEALTH_ASSESSMENT',
  'DOCTYPE.ADVANCE.NEURO':
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BRAIN_HEALTH_ASSESSMENT',
  'DOCTYPE.BLOOD.REPORT': 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BLOOD_REPORT',
  'DOCTYPE.BODY.COMPOSITION': 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BODY_COMPOSITION',
  'DOCTYPE.RADIOLOGY.REPORT': 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.RADIOLOGY_REPORT',
  MHS: 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.MEDICAL_HISTORY_SUMMARY',
  RADIOLOGY_REPORT: 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.RADIOLOGY_REPORT',
} as const;
